import { escapeRegex, join } from "../../utils";
export const MOSCOW_FIAS = '0c5b2444-70a0-4932-980c-b4dc0d3f02b5';
export const ST_PETERSBURG_FIAS = 'c2deb16a-0330-4f05-821f-1d09c93331e6';
export function isCityArea(suggestion) {
    var _a;
    if ((_a = suggestion.data.settlement_type) === null || _a === void 0 ? void 0 : _a.match(/^(тер|гск|промзона|мкр|кв-л)/)) {
        return true;
    }
    if (['Донецкая Народная', 'Луганская Народная', 'Херсонская'].includes(suggestion.data.region)) {
        return false;
    }
    return !suggestion.data.postal_code;
}
export function formatCityResults(_formatted, value, suggestion) {
    const regExp = new RegExp(`(^|\\s|>|-)(${escapeRegex(value).trim().split(/[\s,]+/).filter(el => el.length).join('|')})`, 'igu');
    let name;
    if (suggestion.data.settlement) {
        name = join([
            `<strong>${join([suggestion.data.settlement_type_full, suggestion.data.settlement])}</strong>`,
            suggestion.data.city
        ], ', ');
    }
    else {
        name = `<strong>${join([suggestion.data.city_type === 'г' ? null : suggestion.data.city_type_full, suggestion.data.city])}</strong>`;
    }
    suggestion.value = formatSelectedCity(suggestion);
    let area = suggestion.data.area_with_type;
    if (suggestion.data.area_with_type === suggestion.data.city_with_type || suggestion.data.area_with_type === suggestion.data.settlement_with_type) {
        area = null;
    }
    return join([name, area, formatRegion(suggestion.data, false)], ', ')
        .replace(regExp, "$1<mark>$2</mark>");
}
export function formatSelectedCity(suggestion, withRegion = true, withCityType = false) {
    var _a, _b;
    let city;
    if (suggestion.data.settlement && suggestion.data.settlement !== suggestion.data.city_district) {
        city = join([suggestion.data.settlement_type, suggestion.data.settlement]);
    }
    else {
        city = (suggestion.data.city_type !== 'г' || withCityType) ? (_a = suggestion.data.city_with_type) === null || _a === void 0 ? void 0 : _a.trim() : (_b = suggestion.data.city) === null || _b === void 0 ? void 0 : _b.trim();
    }
    if (!withRegion) {
        return city;
    }
    const region = formatRegion(suggestion.data, true);
    return join([city, region ? `(${region})` : null]);
}
export function formatAddress(suggestion) {
    const address = suggestion.data;
    let district = '';
    if (address.settlement && (['мкр', 'тер', 'р-н', 'пос', 'округ'].includes(address.settlement_type) || address.settlement === address.city_district)) {
        district = join([address.settlement_type, address.settlement]);
    }
    return join([
        district,
        join([address.street_type, address.street]),
        join([address.house_type, address.house, address.block_type, address.block]),
        join([address.flat_type, address.flat]),
    ], ', ');
}
function formatRegion(address, addArea) {
    let region = address.region_with_type;
    if (address.region_type === 'Респ' || address.region_type === 'обл') {
        region = wordBreakReplace(region, address.region_type, address.region_type_full);
    }
    if (address.region_type === 'г') {
        region = address.region;
    }
    if (addArea && +address.capital_marker < 1 && address.area && address.area_with_type !== address.city_with_type) {
        region = join([wordBreakReplace(address.area_with_type, address.area_type, address.area_type_full), region], ', ');
    }
    if (address.city === address.region && !(address.settlement && address.settlement !== address.city_district)) {
        region = null;
    }
    return region;
}
function wordBreakReplace(subject, search, replace) {
    const regExp = new RegExp(`([^а-я]|^)${escapeRegex(search)}(?=[^а-я]|$)`, 'ui');
    return subject.replace(regExp, `$1${replace}`);
}
